const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function Avatar({ person, size = 40 }) {
    const name = person?.name || "?";
    const src = person?.avatar_path ? `${API}/files/${person.avatar_path}` : person?.picture || "";
    if (src) {
        return (
            <img
                src={src}
                alt={name}
                className="shrink-0 rounded-full object-cover"
                style={{ width: size, height: size }}
            />
        );
    }
    const initials =
        name
            .split(/\s+/)
            .map((w) => w[0] || "")
            .slice(0, 2)
            .join("")
            .toUpperCase() || "?";
    return (
        <div
            className="flex shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-lavender to-peach font-semibold text-white"
            style={{ width: size, height: size, fontSize: Math.max(10, Math.round(size * 0.38)) }}
            aria-label={name}
        >
            {initials}
        </div>
    );
}
